import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import {
  EDITOR_MANUAL_URL,
  EDITOR_QUICK_GUIDE_URL,
} from '@/features/editor/lib/manual'

const SUMMARY_ITEMS = [
  '- 🔒 叙事人称锁定（游戏模式）',
  '- 🎬 自动化剧情推进与叙事管理',
  '- 🎲 随机事件与NPC生成',
  '- 🧠 角色认知边界与生动化',
  '- 📝 文本质量优化与约束',
  '- 💾 自动化记忆管理（长/短期）',
  '- 🎨 规范的输出版式',
]

type Props = {
  manualUrl?: string
  quickGuideUrl?: string
}

export function SystemDescriptionBar({
  manualUrl = EDITOR_MANUAL_URL,
  quickGuideUrl = EDITOR_QUICK_GUIDE_URL,
}: Props) {
  const [open, setOpen] = useState(false)
  const contentId = 'system-description-content'

  return (
    <div
      className={cn(
        'border-border/60 bg-muted/30 text-muted-foreground',
        'rounded-lg border'
      )}
    >
      <button
        type='button'
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-controls={contentId}
        className={cn(
          'flex h-9 w-full items-center justify-between gap-2 px-3',
          'text-xs font-medium',
          'hover:bg-muted/40 rounded-lg transition'
        )}
      >
        <span>⚙︎ 引擎说明</span>
        <ChevronDown
          className={cn(
            'h-4 w-4 shrink-0 transition-transform duration-200',
            open ? 'rotate-180' : 'rotate-0'
          )}
        />
      </button>

      <div
        id={contentId}
        className={cn(
          'overflow-hidden px-3',
          'transition-[max-height,opacity] duration-200 ease-out',
          open ? 'max-h-[80vh] pb-3 opacity-100' : 'max-h-0 opacity-0'
        )}
      >
        <div className='space-y-2 text-xs leading-5'>
          <div>元点引擎已为您构筑了AI核心处理逻辑，包括并不限于：</div>
        </div>

        <ul className='mt-2 space-y-1 text-xs leading-5'>
          {SUMMARY_ITEMS.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>

        <div className='mt-2 space-y-2 text-xs leading-5'>
          <div>不建议您自行进行重复设定，增加无意义的工作量与元点消耗。</div>
          <div>
            由您自己的编写错误造成了 AI
            逻辑混乱、响应失败、空回复/截断、版式混乱等问题，将由您自行负责。
          </div>
          <div>
            我们致力于为您提供最佳的创作体验，如有疑惑，请务必参考
            <a
              href={quickGuideUrl}
              target='_blank'
              rel='noreferrer'
              className='text-primary underline-offset-4 hover:underline'
            >
              “快速指引”
            </a>
            和
            <a
              href={manualUrl}
              target='_blank'
              rel='noreferrer'
              className='text-primary underline-offset-4 hover:underline'
            >
              “使用详解”
            </a>
            。
          </div>
        </div>
      </div>
    </div>
  )
}
